/**
 * @author       justin.jeong@zumper.com (Justin Jeong)
 * @copyright    Copyright (c) 2019, Zumper
 * @description  hoodDataReducerCreator.js
 */

import { ON_BROWSER } from '@zcode/nr/es/shared/env'
import { payloadKeyReducer } from '@zcode/reducers'
import type { PriceChartData } from '@zcode/state-type'
import { type NarrowedAction, handleActions } from 'redux-actions'
import type {
  CLEAR_CITY_NAME,
  CLEAR_HOOD_NAME,
  HOOD_NAME_CHANGED,
} from '../../../currentSearch/modules/location/constants'
import type * as detailConstants from '../../constants/detail'
import type * as localeConstants from '../../constants/locale'
import type { ActionTypes } from '../types'

type ActionConstants =
  | {
      clearData: typeof localeConstants.CLEAR_PRICE_CHART_DATA
      clearHoodData: typeof localeConstants.CLEAR_HOOD_PRICE_CHART_DATA
      clearCityName: typeof CLEAR_CITY_NAME
      clearHoodName: typeof CLEAR_HOOD_NAME
      hoodNameChanged: typeof HOOD_NAME_CHANGED
      setData: typeof localeConstants.SET_HOOD_PRICE_CHART_DATA
    }
  | {
      clearData: typeof detailConstants.CLEAR_PRICE_CHART_DATA
      clearHoodData: typeof detailConstants.CLEAR_HOOD_PRICE_CHART_DATA
      clearCityName: typeof CLEAR_CITY_NAME
      clearHoodName: typeof CLEAR_HOOD_NAME
      hoodNameChanged: typeof HOOD_NAME_CHANGED
      setData: typeof detailConstants.SET_HOOD_PRICE_CHART_DATA
    }

export const hoodDataReducerCreator = ({
  clearData,
  clearHoodData,
  clearCityName,
  clearHoodName,
  hoodNameChanged,
  setData,
}: ActionConstants) => {
  return handleActions<PriceChartData, ActionTypes>(
    {
      [clearData]: () => [],
      [clearHoodData]: () => [],
      ...(ON_BROWSER
        ? {
            [clearCityName]: () => [],
            [clearHoodName]: () => [],
            [hoodNameChanged]: () => [],
          }
        : undefined),
      [setData]: payloadKeyReducer<
        PriceChartData,
        'priceChartData',
        NarrowedAction<ActionTypes, typeof setData>['payload']
      >('priceChartData'),
    },
    []
  )
}
